import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface TopbarAction {
  icon: string;
  label: string;
  handler?: () => void;
  disabled?: boolean;
}

@Injectable({ providedIn: 'root' })
export class TopbarActionsService {
  private readonly subtitleSubject = new BehaviorSubject<string>('');
  readonly subtitle$ = this.subtitleSubject.asObservable();

  private readonly actionsSubject = new BehaviorSubject<TopbarAction[]>([]);
  readonly actions$ = this.actionsSubject.asObservable();

  setSubtitle(subtitle: string): void {
    const s = (subtitle || '').trim();
    if (s !== this.subtitleSubject.value) {
      this.subtitleSubject.next(s);
    }
  }

  setActions(actions: TopbarAction[]): void {
    this.actionsSubject.next(actions || []);
  }

  run(action: TopbarAction): void {
    action?.handler?.();
  }

  clear(): void {
    this.setSubtitle('');
    this.setActions([]);
  }
}
